import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router';

export function useNavigationReload(shouldReload: boolean): void {
    const location = useLocation();
    const lastPathRef = useRef<string>(location.pathname);

    useEffect(() => {
        if (!shouldReload) {
            lastPathRef.current = location.pathname;
            return;
        }

        if (location.pathname !== lastPathRef.current) {
            lastPathRef.current = location.pathname;
            window.location.reload();
        }
    }, [location.pathname, shouldReload]);
}
